import React from 'react';
import PropTypes from 'prop-types';
import EditPDFLandingPageSmallUploadPanelLayout from './EditPDFLandingPageSmallUploadPanelLayout';
import EditPDFLandingPageLargeUploadPanelLayout from './EditPDFLandingPageLargeUploadPanelLayout';
import EditPDFLandingPageFullWidthUploadPanelLayout from './EditPDFLandingPageFullWidthUploadPanelLayout';
import EditPDFLandingPageFreeWriteBackgroundLayout from './EditPDFLandingPageFreeWriteBackgroundLayout';

export default class EditPDFLandingPageWrapper extends React.PureComponent {
  componentDidMount() {
    window.Upload.activateUploadButtonById(this.props.ctaId);
    window.Upload.activateUploadButtonById(this.props.mobileCTAId);

    // Allow users to upload photos
    window.Upload.photoToPDF.init();
  }

  render() {
    let landingPageComponent;
    switch (this.props.layout) {
      case 'smallUploadPanel':
        landingPageComponent = <EditPDFLandingPageSmallUploadPanelLayout />;
        break;
      case 'largeUploadPanel':
        landingPageComponent = <EditPDFLandingPageLargeUploadPanelLayout />;
        break;
      case 'fullWidthUploadPanel':
        landingPageComponent = (
          <EditPDFLandingPageFullWidthUploadPanelLayout
            ctaId={this.props.ctaId}
          />
        );
        break;
      case 'freeWriteBackground':
        landingPageComponent = (
          <EditPDFLandingPageFreeWriteBackgroundLayout
            ctaId={this.props.ctaId}
          />
        );
        break;
      default:
        landingPageComponent = <EditPDFLandingPageSmallUploadPanelLayout />;
        break;
    }

    return landingPageComponent;
  }
}

EditPDFLandingPageWrapper.defaultProps = {
  ctaId: 'uploadPDFLarge',
  layout: 'smallUploadPanel',
  mobileCTAId: 'uploadPDFLargeMobile',
};

EditPDFLandingPageWrapper.propTypes = {
  ctaId: PropTypes.string,
  layout: PropTypes.string,
  mobileCTAId: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src-react/EditPDFLandingPage/EditPDFLandingPageWrapper.jsx